import { RefObject } from 'react'
import { FormattedMessage } from 'react-intl'

type InfoDialogProps = {
  maxItems: number
  dialogRef: RefObject<HTMLDialogElement | null>
}

export default function InfoDialog({ maxItems, dialogRef }: InfoDialogProps) {
  return (
    <dialog className="modal" ref={dialogRef}>
      <div className="modal-box">
        <p>
          <FormattedMessage
            id="infoDialog.text1"
            defaultMessage="You’ve selected {max_number_of_emotions} emotions — that’s enough for now."
            values={{
              max_number_of_emotions: maxItems,
            }}
          />
          <br />
          <FormattedMessage
            id="infoDialog.text2"
            defaultMessage="Pause and reflect on what’s already here."
          />
        </p>
        <div className="modal-action">
          <form method="dialog">
            <button className="btn">
              <FormattedMessage id="buttons.ok" defaultMessage="OK" />
            </button>
          </form>
        </div>
      </div>
      <form method="dialog" className="modal-backdrop">
        <button>
          <FormattedMessage id="buttons.close" defaultMessage="Close" />
        </button>
      </form>
    </dialog>
  )
}
